<template>
  <p>404: Not Found</p>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
